module.exports = __webpack_public_path__ + "static/img/special.023b056.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GoodsInfoCard/assets/special.png
// module id = FygL
// module chunks = 103